import script from "./VRadio.vue?vue&type=script&lang=ts&setup=true"
export * from "./VRadio.vue?vue&type=script&lang=ts&setup=true"

import "./VRadio.vue?vue&type=style&index=0&id=0a43fea8&lang=sass"

const __exports__ = script;

export default __exports__